<mat-form-field appearance="outline" [class.has-value]="hasValue" [style.width]="responsiveWidth">
  <mat-label>{{ label }}</mat-label>
  <textarea
    matInput
    title="textarea"
    placeholder="textarea"
    [style.resize]="expandable ? null : 'none'"
    [style.height.px]="height || null"
    [attr.title]="title || label || null"
    [formControl]="control"
    [placeholder]="placeholder || label || ' '"
    [disabled]="disabled"
    [autocomplete]="autocomplete"
    [rows]="rows"
    [cols]="cols"
    [attr.maxlength]="effectiveMaxLength"
    [name]="control.name"
  ></textarea>
  @if (!hideErrors && control?.invalid && control?.errors) {
    <mat-error>{{ errorLabel }}</mat-error>
  }
  @if (description && description.length > 0) {
    <mat-hint>{{ description }}</mat-hint>
  }
</mat-form-field>
